.outer {
  composes: -center from "../util.module.css";
  composes: -expand from "../util.module.css";
}

.container {
  composes: -expand from "../util.module.css";
  display: grid;
  background-color: white;
  font-size: 3rem;
  place-content: center;
  text-align: center;
}
